import React from 'react'
import { Modal, Pressable, StyleSheet, View } from 'react-native'
import { DS } from '@/design-system'

export interface ConfirmDialogModalProps {
  visible: boolean
  title: string
  message: string
  cancelText: string
  confirmText: string
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialogModal({
  visible,
  title,
  message,
  cancelText,
  confirmText,
  onConfirm,
  onCancel
}: ConfirmDialogModalProps) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <Pressable style={styles.backdrop} onPress={onCancel}>
        <Pressable style={styles.dialog} onPress={(e) => e.stopPropagation()}>
          <DS.Text variant="Heading 3/Medium" style={styles.title}>
            {title}
          </DS.Text>
          <DS.Text variant="Body Medium/Regular" style={styles.message}>
            {message}
          </DS.Text>
          <View style={styles.buttonRow}>
            <DS.Button
              type="On Dark"
              variant="Medium/Secondary"
              onPress={onCancel}
              style={styles.button}
            >
              {cancelText}
            </DS.Button>
            <DS.Button
              type="On Light"
              variant="Medium/Primary"
              backgroundColor="Brand/Maroon"
              onPress={onConfirm}
              style={styles.button}
            >
              {confirmText}
            </DS.Button>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  )
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dialog: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 16,
    padding: 24,
    width: 320,
    gap: 16
  },
  title: {
    color: DS.palette['Global/Black'],
    textAlign: 'center'
  },
  message: {
    color: DS.palette['Brand/Dark Grey'],
    textAlign: 'center'
  },
  buttonRow: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 4
  },
  button: {
    flex: 1
  }
})
